import React from "react";
import Main from "../components/Main";
import About from "../components/About";
import { motion } from "framer-motion";
import Projects from "../components/Projects";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import Contact from "../components/Contact";
import "../components/carausel.css";
import Carausel from "../components/Carausel";
import Experience from "../components/Experience";

const Home = () => {
  return (
    <div className=" md:grid grid-cols-12 scroll-smooth ">
      <motion.div
        initial={{ x: -1000, opacity: 0 }}
        animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
        className="md:sticky  hidden col-span-1 text-gray-400  h-[600px]  top-[60px]  items-center  md:flex "
        style={{ writingMode: "vertical-rl" }}
      >
        <div className="bg-gray-400  w-[1px] h-[70%]"></div>
        <span className="mt-3 text-3xl hover:text-[#64ffda]">
          <a
            href="https://www.linkedin.com/in/gurjit-singh-1164a0235"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiFillLinkedin />
          </a>
        </span>
        <span className="my-2 text-3xl hover:text-[#64ffda]">
          <a
            href="https://github.com/Gurjit11"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiFillGithub />
          </a>
        </span>
      </motion.div>
      <div id="main " className="col-span-10 demo-wrapper">
        <Main />
        <Carausel />
        <About />
        <Experience />
        <Projects />
        <Contact />
      </div>
      <motion.div
        initial={{ y: 1000, opacity: 0 }}
        animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
        className="md:sticky  hidden col-span-1 text-gray-400 rotate-180 h-[600px] sticky top-[40px]  items-center  md:flex "
        style={{ writingMode: "vertical-rl" }}
      >
        <span className=" flex items-center hover:text-[#64ffda]">
          <div className="bg-gray-400  w-[1px] mb-2 h-[300px]"></div>
          <a href="mailto: gurjit9320@gmail.com">gurjit9320@gmail.com</a>
        </span>
      </motion.div>
    </div>
  );
};

export default Home;
